var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","min-height":"100px"},attrs:{"src":"https://ttcompai.evchong.com/chatbot/BDonOv7nSONYRXGE","frameborder":"0","allow":"microphone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }